import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.create_phone_error."

export function CreatePhoneErrorToast(props: Props) {
  const {
    id,
    code = null,
    status: responseStatus,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1007: // twilio says the phone number is invalid or unsupported
          return polyglot.t(`${polyglotPrefix}twilio_invalid_body`)
        case 1008: // phone number is unsubscribed from sugarmate
          return polyglot.t(`${polyglotPrefix}twilio_unsubscribed_body`)
        case 1009: // unknown twilio error
          return polyglot.t("error_messaging.twilio_generic_error_body")
        case 1026: // twilio says the phone number is a landline.
          return polyglot.t(`${polyglotPrefix}twilio_landline_body`)
        case 1039: // twilio says country is not supported
          return polyglot.t(`${polyglotPrefix}twilio_unsupported_country_body`)
        default:
          // unspecified invalid response
          if (responseStatus === 422) {
            return polyglot.t(`${polyglotPrefix}invalid_body`)
          }

          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      responseStatus,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
